export default __webpack_public_path__ + "static/google-play-badge-de-4635cd366466563313374396da770bbf.png";